<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de procedimento cirúrgico`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>
<script>

// Components.
import Form from '@/components/parametrizacao/procedimento-cirurgico/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'parametrizacao-procedimento-cirurgico-index' })
        }
    },
    props: {
        id: { type: Number, default: null },
    },
}
</script>